import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";



import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput";

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        id: PropTypes.func.isRequired,
    }


    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.presupuesto.tiposdecosto.detail}
                id={this.props.id}
                successMessage={""}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Tipo de Costo"}
                buttonTittle={"Ver Tipo de Costo"}
                buttonIcon={"fa fa-search fa-lg"}

                saveButton={false}
                closeButton={true}
                className={"ui-modal-dialog"}>
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Datos del tipo</p>
                        <ParadigmaLabeledInput disabled={true} fieldName="nombre" label="Nombre" labelColumns={12} fieldColumns={12} />
                        <ParadigmaLabeledInput disabled={true} fieldName="siglas" label="Siglas" labelColumns={12} fieldColumns={12} />
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_TiposDeCosto/Detail.js